import React from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";

import Input from "components/Input";
import Select from "components/Select";
import Button from "components/Button";
import Label from "components/Label";
import {useEnums} from "../../../hooks";

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

    const { items: FunctionTaskType, isFetched: functionTaskTypeIsFetched } = useEnums('FunctionTaskType');

  const organization = useOrganizations();

  return (
    <Grid.Row gutter={[20, 20]} align="bottom">
        <Grid.Col span={12}>
            <Label title={t('column_name')}>
                <Input
                    value={params.content_uz || ''}
                    onChange={(value) => setParams({content_uz:value})}
                />
            </Label>
        </Grid.Col>
      <Grid.Col xs={12}>
        <Label title={t("column_organization")}>
          <Select
            onChange={(v) => setParams({ organization_id: v })}
            showSearch
            options={[
              { label: t("all_organization"), value: "" },
              ...organization.items.map((item) => ({
                label: item.name[i18n.language],
                value: item.id,
              })),
            ]}
            value={Number(params.organization_id) || ""}
            placeholder={t("column_organization")}
            disabled={!organization.isFetched}
          />
        </Label>
      </Grid.Col>

        <Grid.Col span={10}>
            <Label title={t('column_type')}>
                <Select
                    name={t('type')}
                    value={params.type || undefined}
                    options={
                        FunctionTaskType.length && functionTaskTypeIsFetched
                            ? FunctionTaskType.filter(item => item !== 'FUNCTION' && item !== 'STATE_SERVICE').map(item => ({
                                label: t(item),
                                value: item
                            }))
                            : []
                    }
                    onChange={(value) => setParams({type: value})}
                />
            </Label>
        </Grid.Col>

        <Grid.Col span={10}>
            <Label title={t('column_can_be')}>
                <Select
                    name={t('can_be')}
                    value={params.can_be || undefined}
                    options={
                        FunctionTaskType.length && functionTaskTypeIsFetched
                            ? FunctionTaskType.filter(item => item !== 'STATE_SERVICE').map(item => ({
                                label: t(item),
                                value: item
                            }))
                            : []
                    }
                    onChange={value => setParams({can_be: value})}
                />
            </Label>
        </Grid.Col>

      <Grid.Col span={4}>
        <Button
            style={{width: '100%'}}
          background="blue"
          color="white"
          border="blue"
          radius="sm"
          onClick={() => setSearch((prev) => prev + 1)}>
          <Icons.Search /> {t("find")}
        </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;
